<template>
    <v-container style="padding: 0">
        <v-row>
            <v-col cols="6" class="py-0">
                <v-select
                    id="province"
                    v-model="province"
                    style="width: 100%"
                    @change="selectProvince"
                    :label="$t('user.province')"
                    item-value="name"
                    item-text="name"
                    :items="provinces"
                    :error-messages="errors.province"
                />
            </v-col>
            <v-col
                cols="6"
                class="py-0"
                v-if="level > 1"
                style="padding-left: 0"
            >
                <v-select
                    id="city"
                    v-model="city"
                    style="width: 100%"
                    @change="selectCity"
                    :label="$t('user.city')"
                    item-value="name"
                    item-text="name"
                    :items="cities"
                    :error-messages="errors.city"
                />
            </v-col>
            <v-col cols="12" class="py-0" v-if="level > 2">
                <v-select
                    id="district"
                    v-model="district"
                    style="width: 100%"
                    @change="selectDistrict"
                    :label="$t('user.district')"
                    item-value="name"
                    item-text="name"
                    :items="districts"
                    :error-messages="errors.district"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props: {
        value: { type: Array }, //先只支持array
        level: { type: Number, default: 3 }
    },
    data() {
        return {
            selected: [],
            all: [],
            provinces: [],
            cities: [],
            districts: [],
            province: '',
            city: '',
            district: '',
            errors: {}
        }
    },
    mounted() {
        this.getAll()
    },
    watch: {
        value(nv) {
            if (!nv) {
                this.clearAll()
            } else {
                if (!nv[0]) this.clearAll() //可能是 [null,null,null]
                if (!this.all || this.all.length === 0) {
                    this.getAll()
                } else {
                    this.selectAreaByNames(nv)
                }
            }
        }
    },
    methods: {
        getAll() {
            this.$api.area.getAll(this.level, (res) => {
                this.all = res
                this.provinces = this.all.province
                if (this.value) {
                    if (Array.isArray(this.value)) {
                        this.selectAreaByNames(this.value)
                    }
                }
            })
        },
        selectProvince() {
            this.initCities()
            this.emitSelection()
        },
        initCities() {
            for (var i = 0; i < this.provinces.length; i++) {
                if (this.provinces[i].name == this.province) {
                    this.cities = this.provinces[i].city
                    this.city = null
                    this.districts = [] //清空区县选项
                    this.district = null
                    break
                }
            }
        },
        selectCity() {
            this.initDistricts()
            this.emitSelection()
        },
        initDistricts() {
            for (var i = 0; i < this.cities.length; i++) {
                if (this.cities[i].name == this.city) {
                    this.districts = this.cities[i].district
                    this.district = null
                    break
                }
            }
        },
        selectDistrict() {
            this.emitSelection()
        },
        selectAreaByNames(names) {
            if (!names) {
                this.clearAll()
                return
            }
            var ps = this.all.province
            // console.log(ps)
            prov: for (var i = 0; i < ps.length; i++) {
                //province
                var curp = ps[i]
                if (curp.name == names[0]) {
                    this.province = curp.name
                    this.initCities()
                    var cs = ps[i].city
                    for (var j = 0; j < cs.length; j++) {
                        var curc = cs[j]
                        if (curc.name == names[1]) {
                            this.province = curp.name
                            this.city = curc.name
                            this.cname = curc.name
                            this.initDistricts()
                            var ds = cs[j].district
                            for (var k = 0; k < ds.length; k++) {
                                var curd = ds[k]
                                if (ds[k].name == names[2]) {
                                    this.province = curp.name
                                    this.city = curc.name
                                    this.district = curd.name
                                    break prov
                                }
                            }
                        }
                    }
                }
            }
        },
        clearAll() {
            this.province = null
            this.city = null
            this.district = null
        },
        emitSelection() {
            this.$emit('selected', this.province, this.city, this.district)
        }
    }
}
</script>
